var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMultipleFiles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9H4.95C3.67721 9 3.04081 9 2.64541 9.39541C2.25 9.79081 2.25 10.4272 2.25 11.7V13.05C2.25 14.3228 2.25 14.9592 2.64541 15.3546C3.04081 15.75 3.67721 15.75 4.95 15.75H6.3C7.57279 15.75 8.20919 15.75 8.60459 15.3546C9 14.9592 9 14.3228 9 13.05V12.375",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 5.36572H8.06523C6.79244 5.36572 6.15605 5.36572 5.76064 5.76113C5.36523 6.15653 5.36523 6.79293 5.36523 8.06572V9.41572C5.36523 10.6885 5.36523 11.3249 5.76064 11.7203C6.15605 12.1157 6.79244 12.1157 8.06523 12.1157H9.41523C10.688 12.1157 11.3244 12.1157 11.7198 11.7203C12.1152 11.3249 12.1152 10.6885 12.1152 9.41572V8.74072",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.95C9 3.67721 9 3.04081 9.39541 2.64541C9.79081 2.25 10.4272 2.25 11.7 2.25H13.05C14.3228 2.25 14.9592 2.25 15.3546 2.64541C15.75 3.04081 15.75 3.67721 15.75 4.95V6.3C15.75 7.57279 15.75 8.20919 15.3546 8.60459C14.9592 9 14.3228 9 13.05 9H11.7C10.4272 9 9.79081 9 9.39541 8.60459C9 8.20919 9 7.57279 9 6.3V4.95Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMultipleFiles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multiple-files.d01e13222a18e54aaa87dc56aa4525a2.svg";